import { Helper } from "@helpers/functions";
import { Model } from "./model";

export class Notification extends Model {
	public constructor(
		id: string,
		private name: string,
		private enabled: boolean = false
	) {
		super();
		this.setId(id);
		this.enabled = Helper.getCookie("notification_" + this.getId()) === "true";
	}

	public getName(): string {
		return this.name;
	}

	public setEnabled(b: boolean): void {
		this.enabled = b;
	}

	public getEnabled(): boolean {
		return this.enabled;
	}
}
